import { render, staticRenderFns } from "./getInvolvedContent.vue?vue&type=template&id=90b81d3a"
import script from "./getInvolvedContent.vue?vue&type=script&lang=js"
export * from "./getInvolvedContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports